import React, { useEffect } from "react";
import { checkStatus } from "./api";
import { Spinner, ContentSection, Wrapper } from "@vwfs-bronson/bronson-react";
import { Output } from "../../Text";
import moment from "moment";

const IdentityPending = ({
  identityID,
  onSuccess,
  onError,
  onFail,
  addToDatalayer,
  onLoad,
}) => {
  let transactionId = "";
  let idNowUrl = "";
  let previousStatus = "";
  let previousTimestamp = "";
  let salesChannel = {};

  const checkPolling = () => {
    const finishPoll = () => {
      clearInterval(timer);
      clearTimeout(timeoutTimer);
    };

    const esignPendingPolling = async (identificationStatusResult) => {
      transactionId = identificationStatusResult.transactionId;
      idNowUrl = identificationStatusResult.idNowUrl;
      salesChannel = identificationStatusResult?.data?.salesChannel;
      let prefillData = identificationStatusResult?.data;
      prefillData.transaction = {id:transactionId}
      addToDatalayer(prefillData);
      if (salesChannel) {
        onLoad(salesChannel);
      }
      switch (identificationStatusResult.status) {
        case "ACCEPTED":
          clearInterval(timer);
          clearTimeout(timeoutTimer);
          onSuccess(identificationStatusResult.redirectUrl, prefillData);
          break;
        case "INITIALIZED":
          // Skip and keep polling
          previousStatus = identificationStatusResult.status;
          previousTimestamp = identificationStatusResult.timestamp;
          break;
        case "REJECTED":
          /**
           * https://jira.platform.vwfs.io/browse/GFTDE-793
           * https://jira.platform.vwfs.io/browse/GFTDE-1058
           * Skip rejected status and keep polling new status in case this is the second or later identification attempt.
           * If the previous status was INITIALIZED and is now REJECTED, we can safely assume the reject is new and stop polling.
           * Also if the current result was set within the last 3 minutes, we can assume the reject is valid and stop polling.
           */
          const timestampHasChanged =
            !!previousTimestamp &&
            !!identificationStatusResult.timestamp &&
            previousTimestamp !== identificationStatusResult.timestamp;
          const timestampIsNew =
            !!identificationStatusResult.currentTime &&
            moment(identificationStatusResult.currentTime)
              .subtract(3, "minutes")
              .isBefore(moment(identificationStatusResult.timestamp));
          if (
            previousStatus === "INITIALIZED" ||
            (timestampHasChanged && previousStatus === "REJECTED") ||
            timestampIsNew
          ) {
            clearInterval(timer);
            clearTimeout(timeoutTimer);
            onFail({ transactionId, idNowUrl });
            break;
          }
          previousStatus = identificationStatusResult.status;
          previousTimestamp = identificationStatusResult.timestamp;
          break;
        default:
          clearInterval(timer);
          clearTimeout(timeoutTimer);
          onError();
          break;
      }
    };

    const executePoll = async () => {
      if (!isPending) {
        isPending = true
        try {
          const identificationStatusResult = await checkStatus(identityID);
          esignPendingPolling(identificationStatusResult);
        } catch (error) {
          finishPoll();
          onError(error);
        }
        isPending = false;
      }
    };

    const timeoutReached = () => {
      finishPoll()
      onError()
    };

    let isPending = false
    const TIMEOUT = 250000
    const WAIT_TIME = 3000
    const timeoutTimer = setTimeout(() => timeoutReached(), TIMEOUT)
    const timer = setInterval(executePoll, WAIT_TIME)
  }

  useEffect(() => {
    checkPolling()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Spinner fullPage />
      <Wrapper pageWrapper>
        <ContentSection pageWrap>
          <ContentSection.ComponentWrapper>
            <h3>{Output.resolveAsMarkdown("pages.identPending.title")}</h3>
          </ContentSection.ComponentWrapper>
        </ContentSection>
        <ContentSection pageWrap>
          <ContentSection.ComponentWrapper>
            <ContentSection.ComponentWrapper>
              {Output.resolveAsMarkdown("pages.identPending.explanationText")}
              {Output.resolveAsMarkdown(
                "pages.identPending.additionalDisclaimer"
              )}
            </ContentSection.ComponentWrapper>
          </ContentSection.ComponentWrapper>
        </ContentSection>
      </Wrapper>
    </>
  );
};

export { IdentityPending };
